import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from 'material-ui';

const INITIAL_STATE = {
  valueLabel: null,
  searchTextLabel: ''
};

class AutoCompleteWithInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      searchTextLabel: props.value || ''
    };
  }

  componentDidUpdate = () => {
    if (this.props.value !== this.state.searchTextLabel) {
      this.setState({ searchTextLabel: this.props.value, valueLabel: null });
    }
  };

  _onSelectItemLabel = (data, index) => {
    if (index === -1) {
      this.setState({ searchTextLabel: data });
      this.props.onChange(data);
    } else {
      this.setState({ valueLabel: data });
      this.props.onChange(data);
    }
  };

  _onUpdateInputLabel = searchTextLabel => {
    this.setState({ searchTextLabel, valueLabel: null });
    this.props.onChange(searchTextLabel);
  };

  render() {
    return (
      <div className="autocomplete-inside-bootstrap">
        <AutoComplete
          openOnFocus
          onNewRequest={this._onSelectItemLabel}
          onUpdateInput={this._onUpdateInputLabel}
          hintText={this.props.hintText}
          searchText={this.state.searchTextLabel}
          filter={this.props.filter || AutoComplete.fuzzyFilter}
          popoverProps={{ style: { overflowY: 'auto', height: 400 } }}
          dataSource={this.props.dataSource}
        />
      </div>
    );
  }
}
AutoCompleteWithInput.propTypes = {
  hintText: PropTypes.string,
  value: PropTypes.string,
  dataSource: AutoComplete.propTypes.dataSource,
  onChange: PropTypes.func,
  filter: AutoComplete.propTypes.filter
};

export default AutoCompleteWithInput;



// WEBPACK FOOTER //
// ./src/components/AutoCompleteWithInput.js